import React from 'react';
import { IconButton } from '@material-ui/core';
import BarcodeIcon from '@material-ui/icons/CropFree';
import { useManageContext } from '../../contexts/ManageContext/ManageContext';
import Tooltip from '@material-ui/core/Tooltip';

const Scanner = (props: { target: string; style?: any }) => {
  const { target } = props;
  const { dispatch, state } = useManageContext();
  const visible = state.barcode && state.barcode.visible;
  return (
    <Tooltip title="Barcode scanner" aria-label="scanner">
      <IconButton
        onClick={() => {
          dispatch({
            type: 'barcode-changed',
            data: { target: target, visible: !visible },
          });
        }}
      >
        <BarcodeIcon style={props.style} />
      </IconButton>
    </Tooltip>
  );
};

export default Scanner;
